export const OJT_MANAGE_BOOKINGS_URL = "/dl/bookings";
